import { z } from 'zod'

import {
  BidDomainSelectModelFiltersSchema,
  BidDomainSelectModelSchema,
} from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { SelectBidOutputSchema } from './select-bid.models.ts'

// Select a list of bids by projectId or agencyTeamId
export const ListBidsInputSchema = BidDomainSelectModelSchema.pick({
  projectId: true,
})
  .extend(BidDomainSelectModelFiltersSchema.pick({ status: true }).shape)
  .required()

export type ListBidsInput = ZodInfer<typeof ListBidsInputSchema>

export const ListBidOutputSchema = SelectBidOutputSchema.extend({
  isPreferred: z.boolean(),
})

export type ListBidOutput = ZodInfer<typeof ListBidOutputSchema>

export const ListBidsOutputSchema = ListBidOutputSchema.array()

export type ListBidsOutput = ZodInfer<typeof ListBidsOutputSchema>
